<template>
    <span>
        <v-card id="email-card" class="pa-3" dark v-show="showEmailCard">
             booking-busan@limotourkorea.com
        </v-card>
        <v-card id="phone-card" class="pa-3" dark v-show="showPhoneCard">
            (051) 747-2040
        </v-card>
        <v-card id="address-card" class="pa-3" dark v-show="showAddressCard">
            부산광역시 해운대구 해운대로 620, 해운대라뮤에뜨빌딩 310호
        </v-card>

        <v-btn id="email-button" fab dark small color="red" @click.stop="zoomOut" @mouseover="showEmailCard=true" @mouseleave="showEmailCard=false" to="/contact">
            <v-icon>mdi-email</v-icon>
        </v-btn>
        <v-btn id="address-button" fab dark small color="indigo" @click.stop="zoomOut" @mouseover="showAddressCard=true" @mouseleave="showAddressCard=false">
            <v-icon>mdi-home-modern</v-icon>
        </v-btn>
        <v-btn id="phone-button" fab dark small color="green" @click.stop="zoomOut" @mouseover="showPhoneCard=true" @mouseleave="showPhoneCard=false">
            <v-icon>mdi-phone</v-icon>
        </v-btn>
    </span>
</template>
<script>
export default {
    name: 'FabSpeedDial',
    data: () => ({
      showPhoneCard: false,
      showAddressCard: false,
      showEmailCard: false
    })
  }
</script>

<style lang="scss">
#email-card {
    position: fixed;
    right: 60px;
    bottom: 185px;
}
#phone-card {
    position: fixed;
    right: 60px;
    bottom: 85px;
}
#address-card {
    position: fixed;
    right: 60px;
    bottom: 135px;
}
#email-button {
    position: fixed;
    right: 15px;
    bottom: 190px;
}
#phone-button {
    position: fixed;
    right: 15px;
    bottom: 90px;
}
#address-button {
    position: fixed;
    right: 15px;
    bottom: 140px;
}
</style>
